import React from 'react';
import { TypedMemo } from '../../common/types';
import { Panel } from '../../music24/components/primitives/Panel';
import styles from './SMLStatCardsSkeleton.module.scss';

/**
 * Keeps the cards' shape while the numbers load, so the page below them does
 * not jump once they arrive.
 */
const SMLStatCardsSkeletonComponent: React.FC = () => {
  return (
    <div className={styles.grid}>
      {[0, 1, 2, 3].map((key) => (
        <Panel key={key} className={styles.card}>
          <div className={styles.label} />
          <div className={styles.value} />
        </Panel>
      ))}
    </div>
  );
};

export const SMLStatCardsSkeleton = TypedMemo(SMLStatCardsSkeletonComponent);
